import generatePath from 'utils/generatePath';

export const isSignedMediaUrl = url =>
  typeof url === 'string' && (url.includes('Policy=') || url.includes('Signature='));

/**
 * Keep a signed (or blob) avatar when a metadata emit omits avatar or sends an
 * unsigned private CDN URL. Host-agnostic: staging/preview/prod all use Policy=.
 */
export const resolvePreservedAvatar = ({ incomingAvatar, existingAvatar, fallbackAvatar } = {}) => {
  const current = [existingAvatar, fallbackAvatar].find(
    url => typeof url === 'string' && url.length > 0,
  );
  const hasIncoming = typeof incomingAvatar === 'string' && incomingAvatar.length > 0;

  if (!hasIncoming) {
    return current;
  }
  if (current && isSignedMediaUrl(current) && !isSignedMediaUrl(incomingAvatar)) {
    return current;
  }
  return generatePath(incomingAvatar);
};
